import * as imgix from '../providers/imgix';
import * as none from '../providers/none';

const DEFAULT_CONFIG = {
  isEnabled: false,
};

let config = { ...DEFAULT_CONFIG };

export function init(
  newConfig = {
    isEnabled: false,
  }
) {
  config = { ...config, ...newConfig };
}

export function isEnabled() {
  return config.isEnabled;
}

export function getCurrentImagesCdnService() {
  return isEnabled() ? imgix : none;
}
